import styled from 'styled-components';

import { Text } from 'apps/auth/components/common/Text/Text';
import media from 'apps/auth/theme/media';

export const CalculatorFrame = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
`;
export const CalculatorFrameTop = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: center;
`;
export const CalculatorFrameBottom = styled.div`
    margin-top: 24px;
    position: relative;
`;

export const CalculatorInputLabel = styled(Text)`
    padding: 4px 0;
`;

export const CalculatorAmountContainer = styled.div`
    display: flex;
    column-gap: 16px;
`;

export const CalculatorAmountBlock = styled.label`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    min-width: ${(props) => (props.isDouble ? '144px' : null)};
    width: ${(props) => (props.isDouble ? '50%' : null)};
`;

export const CalculatorInputWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    padding: 12px 0;

    ${media.desktop1920} {
        padding: 20px 24px;
    }

    input {
        font-family: var(--font-display1), sans-serif;
        background-color: transparent;
        border: none;
        box-sizing: border-box;
        display: inline-block;
        padding: 0;
        width: 100%;
        font-size: 40px;
        line-height: 48px;
        cursor: auto;
        text-align: center;
        color: ${(props) => (props.$isError ? props.theme.pink_100 : 'inherit')};

        ${media.desktop1920} {
            font-size: 48px;
            line-height: 64px;
        }
    }
`;

export const Helper = styled.span`
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: ${(props) => (props.noPadding ? null : '3px 5px 3px 7px')};

    ${media.tablet720} {
        padding: ${(props) => (props.noPadding ? null : '7px 5px 7px 7px')};
    }
`;

export const PseudoDropdown = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 3px 5px 3px 7px;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.grey_28_tr};

    ${media.tablet720} {
        padding-bottom: 7px;
        padding-top: 7px;
    }
`;
